import SuperAdminUsersTable from '@/components/super-admin/users/SuperAdminUsersTable';

function SuperAdminUsers() {
  return (
    <main className="flex flex-col w-full h-full">
      <h1 className="mb-2 font-bold">Users</h1>
      <SuperAdminUsersTable />
    </main>
  );
}

export default SuperAdminUsers;
